import {
  API_CALL_FAILURE,
  API_CALL_REQUEST,
  API_CALL_SUCCESS,
  CREATE_SEARCH,
  CREATE_SEARCH_SESSION,
} from 'actions/actionConstants'
import { apiReducerSwitch, createAppReducer } from 'lib/redux/reducerUtils'
import { EXTRACT_DATES, EXTRACT_OCCUPANCY } from 'actions/apiActionConstants'

export const initialSearchState: App.SearchState = {
  searches: {},
  searchSessions: {},
  extractedDates: {},
  extractedOccupancies: {},
}

const apiCalls = apiReducerSwitch<App.SearchState>({
  [EXTRACT_DATES]: {
    request: (state, action) => {
      const {
        query,
      } = action

      return ({
        ...state,
        extractedDates: {
          ...state.extractedDates,
          [query]: {
            fetching: true,
            checkinDate: undefined,
            checkoutDate: undefined,
            flexibleMonths: undefined,
            flexibleNights: undefined,
          },
        },
      })
    },
    success: (state, action) => {
      const {
        query,
      } = action

      const {
        checkinDate,
        checkoutDate,
        flexibleMonths,
        flexibleNights,
      } = action.data

      return ({
        ...state,
        extractedDates: {
          ...state.extractedDates,
          [query]: {
            checkinDate,
            checkoutDate,
            flexibleMonths,
            flexibleNights,
            fetching: false
          },
        },
      })
    },
    failure: (state, action) => {
      const {
        query,
      } = action

      return ({
        ...state,
        extractedDates: {
          ...state.extractedDates,
          [query]: {
            fetching: false,
            checkinDate: undefined,
            checkoutDate: undefined,
            flexibleMonths: undefined,
            flexibleNights: undefined,
          },
        },
      })
    },
  },
  [EXTRACT_OCCUPANCY]: {
    request: (state, action) => {
      const { query, } = action

      return ({
        ...state,
        extractedOccupancies: {
          ...state.extractedOccupancies,
          [query]: { fetching: true },
        },
      })
    },
    success: (state, action) => {
      const { query, } = action
      const { occupancies } = action.data

      return ({
        ...state,
        extractedOccupancies: {
          ...state.extractedOccupancies,
          [query]: { occupancies, fetching: false },
        },
      })
    },
    failure: (state, action) => {
      const { query, } = action

      return ({
        ...state,
        extractedOccupancies: {
          ...state.extractedOccupancies,
          [query]: { fetching: false },
        },
      })
    },
  },
})

export default createAppReducer<App.SearchState>(initialSearchState, {
  [API_CALL_SUCCESS]: apiCalls,
  [API_CALL_REQUEST]: apiCalls,
  [API_CALL_FAILURE]: apiCalls,
  [CREATE_SEARCH]: (state, action) => {
    const { key, searchId, searchContext, searchEvent } = action

    return {
      ...state,
      searches: {
        ...state.searches,
        [key]: {
          searchId,
          searchContext: searchContext ?? state.searches[key]?.searchContext,
          searchEvent,
        },
      },
    }
  },
  [CREATE_SEARCH_SESSION]: (state, action) => {
    const { key, searchSessionId } = action

    return {
      ...state,
      searchSessions: {
        ...state.searchSessions,
        [key]: { searchSessionId }
      },
    }
  },
})
